export * from './damageReportProcessSteps';
export * from './damageReportReasons';
export * from './damageReportFieldNames';
export * from './damageReportTypes';
export * from './damageReportResponsibilities';
export * from './damageReportCauses';
export const maxNumberOfAccidentOpponents = 10;
